<template>
  <div class="player-box">
    <div class="player-title">
      <div class="title">第一节、东方智慧与中式观看</div>
      <div class="desc">
        <span>总章：3节</span>
        <span>总时长：00:50:11</span>
      </div>
    </div>
    <div class="aliplayer">
      <!-- <vue-aliplayer-v2 :source="source" ref="VueAliplayerV2" :options="options" replayByVidAndPlayAuth /> -->
      <vue-aliplayer-v2
        v-if="isShow"
        ref="VueAliplayerV2"
        :source="source"
        :options="options"
        @ended="endedFunc"
      />
    </div>
    <Question
      :videoQuestionList="videoQuestionList"
      @changeQuestionStatus="changeQuestionStatus"
      v-if="isQuestion"
    />
  </div>
</template>

<script>
import { chapterRandom } from "@/api/CourseCenter";
import Question from "./Question.vue";
export default {
  name: "Player",
  components: {
    Question,
  },
  props: {
    playAuth: String,
    vid: String,
    chapterId: [String, Number],
  },
  watch: {
    // license: {
    //   domain: "example.com", // 申请 License 时填写的域名
    //   key: "example-key" // 申请成功后，在控制台可以看到 License Key
    // }
    playAuth: {
      handler(newVal) {
        if (!newVal) return;
        this.videoAuth = newVal;
        this.options.playauth = newVal;
        this.options.vid = this.vid;
        this.cId = this.chapterId;
        this.isShow = true;
      },
      immediate: true,
    },
  },
  data() {
    return {
      options: {
        // isLive: true, //切换为直播流的时候必填
        // format: 'm3u8'  //切换为直播流的时候必填
        width: "100%",
        height: "100%",
        autoplay: false,
        vid: "bf9df3e2c915400e8517ef0e584a340f",
        license:{domain: "ykmeik.com",key: "tPno6NEBngJXgBuPOf6f35a710540471587ac360e1e79b558"},
        playauth: "",
      },
      source: "",
      isShow: false,
      cId: "",
      videoQuestionList: [],
      isQuestion: false,
    };
  },
  mounted() {
    this.setHeight();
    // setTimeout(() => {
    //   this.chapterRandomFunc();
    // }, 1000);

    // // 禁用右键菜单
    // document.addEventListener("contextmenu", (e) => {
    //   e.preventDefault();
    // });
    //
    // // 禁用开发者工具
    // document.addEventListener("keydown", (e) => {
    //   if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
    //     e.preventDefault();
    //   }
    // });
  },
  methods: {
    changeQuestionStatus() {
      this.isQuestion = false;
    },
    chapterRandomFunc() {
      let params = {
        chapterId: this.cId,
        num: 10,
      };
      chapterRandom(params)
        .then((res) => {
          console.log("chapterRandom", res);
          this.videoQuestionList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    endedFunc() {
      console.log("播放完毕");
      this.isQuestion = true;
    },
    setHeight() {
      let ele = document.querySelector(".aliplayer");
      let W = ele.clientWidth;
      console.log("playerHeight", W);
      let H = parseInt((664 * W) / 1220) + "px";
      ele.style.height = H;
    },
  },
};
</script>

<style lang="scss">
.player-box {
  .player-title {
    margin-bottom: 29px;
    display: flex;
    justify-content: space-between;
    .title {
      line-height: 20px;
      font-size: 20px;
      color: #fff;
    }
    .desc {
      font-size: 13px;
      color: #aaa;
      span {
        margin-left: 48px;
        display: inline-block;
        line-height: 20px;
      }
    }
  }
  .aliplayer {
    margin-bottom: 52px;
  }
}
</style>
